export default [
  'forms_data'
]



// WEBPACK FOOTER //
// ./src/utils/hiddenReportColumns/hiddenColumns.js